export function buildEvalModelsPageQueryV1(workspaceId: number, projectId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.EvaluationModels.Queries.EvalModelsPageQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
	}
}

export function buildEvalModelByIdQueryV1(workspaceId: number, projectId: number, evalModelId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.EvaluationModels.Queries.EvalModelByIdQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvalModelId': evalModelId,
	}
}